<template>
  <div
    class="connected-switch-component"
    :class="{ 'connected-switch-component--min': verticalNavMenuItemsMin }">
    <div class="flex items-center full-width flex-center" v-if="!verticalNavMenuItemsMin">
      <switch-ped-bot class="mr-4 opened-nav-button flex items-center" v-model="status">
        <span slot="on">Online</span>
        <span slot="off">Offline</span>
      </switch-ped-bot>
    </div>

    <div v-else>
      <vs-switch class="mr-8 opened-nav-button flex items-center" v-model="status">
      </vs-switch>
    </div>
  </div>
</template>

<script>

import user from '@/http/requests/user'
import SwitchPedBot from "@/components/switch/SwitchPedBot";
import { getIp } from '@/utils'

export default {
  components: {
    SwitchPedBot
  },
  props: {
    verticalNavMenuItemsMin: {
      type: Boolean,
      required: true
    },
    userStatus: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      status: this.userStatus,
      statusTimeout: null,
    };
  },
  watch: {
    async status(val) {
      clearTimeout(this.statusTimeout);
      this.statusTimeout = setTimeout(async () => {
      const ip = await getIp();
      if (val) {
        return user.connected(ip).then(() => {
          this.$emit('upateUserStatus', val);
        });
      }
      return user.disconnected(ip).then(() => {
        this.$emit('upateUserStatus', val);
      });
    }, 1000);
    },
    userStatus(val) {
      this.status = val;
    }
  }
}

</script>

<style lang="scss">
.connected-switch-component {
  padding: 0px;
  &--min {
    padding: 10px 5px;

    .vs-switch {
      height: 16px;
      &--circle {
        height: 12px;
        width: 12px;
      }
    }

    .vs-switch-active {
      .vs-switch {
        &--circle {
          left: 8px;
        }
      }
    }
  }
}

.flex-center {
  justify-content: center;
}

.vs-dialog-text {
  white-space: pre-line;
}

// .opened-nav-button {
//   width: 30% !important;
// }

.clear {
  margin: 5px 10px 5px 0px;
  cursor: pointer;
}

.list {
  margin-top: 30px;
}

.vs-button-filled {
  color: #fff !important;
}

.transferrer-dropdown {
  .truncate {
    width: 95%;
  }

  &.con-vs-dropdown--menu {
    width: auto !important;
    max-width: 365px !important;
  }
}
</style>
